/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FolhasPagamentoAliases {
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_1 = 'date-field-1',
  DECK_FOLHAS_PAGAMENTO = 'deck-folhas-pagamento',
  FETCH_FOLHAS_PAGAMENTO = 'fetch-folhas-pagamento',
  FIELD_DT_FIM = 'field-dt-fim',
  FIELD_DT_FINAL = 'field-dt-final',
  FIELD_DT_GERACAO = 'field-dt-geracao',
  FIELD_DT_INICIAL = 'field-dt-inicial',
  FIELD_DT_INICIO = 'field-dt-inicio',
  FIELD_IMAGE = 'field-image',
  FILTER_FOLHAS_PAGAMENTO = 'filter-folhas-pagamento',
  FILTERED_LIST = 'filtered-list',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  IMAGE_DOWNLOAD = 'image-download',
  PANEL_0 = 'panel-0',
  PANEL_MAIN = 'panel-main',
  TEXT_DT_FINAL = 'text-dt-final',
  TEXT_DT_GERACAO = 'text-dt-geracao',
  TEXT_DT_INICIAL = 'text-dt-inicial',
}
export { FolhasPagamentoAliases };
